import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from 'antd';
import {
  DashboardOutlined,
  LeftOutlined,
  RightOutlined
} from '@ant-design/icons';
import { IndicatorWrapper } from '../settings/dashboard/IndicatorWrapper';

const minWidth = '25%';
const maxWidth = '100%';

const DashboardDrawer = ({ setDisplay }) => {
  const [sliderWidth, setSliderWidth] = useState(minWidth);

  const setDashBoardSize = () => {
    if (sliderWidth === minWidth) setSliderWidth(maxWidth);
    else setSliderWidth(minWidth);
    setDisplay(sliderWidth === minWidth ? 1 : 0);
  };

  const isMinVersion = () => {
    return sliderWidth === minWidth;
  };

  return (
    <div className="dashboard-drawer" style={{ width: sliderWidth }}>
      <div
        className="dashboard-drawer-head"
        style={{ justifyContent: isMinVersion() ? 'space-between' : 'start' }}
      >
        <Button onClick={() => setDashBoardSize()} type="link">
          {sliderWidth === minWidth ? <LeftOutlined /> : <RightOutlined />}
        </Button>
        <DashboardOutlined style={{ marginLeft: isMinVersion() ? 0 : 24 }} />
        {!isMinVersion() && (
          <Typography.Text>Mon tableau de bord</Typography.Text>
        )}
      </div>
      <IndicatorWrapper
        colSpan={isMinVersion() ? 24 : 12}
        bigVersion={!isMinVersion()}
      />
    </div>
  );
};

DashboardDrawer.propTypes = {
  setDisplay: PropTypes.func.isRequired
};

export { DashboardDrawer };
